import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
Vue.use(Vuex);
/**
 * @func require.context()  webpack提供的能力
 * @param {String} directory 表示检索的目录
 * @param {Boolean} useSubdirectories = true 是否检索子目录
 * @param {RegExp} regExp = /^\.\/.*$/ 文件匹配正则
 * @param {String} mode = 'sync'
 * @return {Function} return { moudleFiles(key), keys(), id }
 */

var moudleFiles = require.context('./modules', false, /\.js$/);

var modules = moudleFiles.keys().reduce(function (modules, modulePath) {
  var moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  modules[moduleName] = (moudleFiles(modulePath) || {}).default;
  return modules;
}, {});
var store = new Vuex.Store({
  modules: modules,
  getters: getters
});
export default store;